import React from 'react';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Paper from '@material-ui/core/Paper';
import VideoSelect from '../../../components/molecule/FormFields/VideoSelect';
import { AlertModal } from '../../../components/molecule/Modals/AlertModal';
import Input from '@material-ui/core/Input';
import Icon from '@material-ui/core/Icon';
import * as apiServices from '../../../services/apiServices';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import { startPolling } from '../../../modules/UploadQueue';
import StatusButton from '../../../components/molecule/StatusIndicators/StatusButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import FileUploader from '../../../components/atomic/Inputs/FileUploader';
import MoreDetails from '../../Exercise/EditForm/MoreDetails';
import {
  ACCEPTED_VIDEO_FORMATS,
  DEFAULT_EXERCISE_VIDEO_ORIENTATION,
  STREAMING_STATUS,
} from '../../../core/constants';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  max-width: 800px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 10px;
`
const StretchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  ${'' /* height: 100%; */}
  // background: rgba(0,0,0,0.1);
  ${'' /* flex-shrink: 1; */}
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`

const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`
  
const InputStyled = styled(Input)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`
const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`

const Aside = styled.div`
  display: flex;
  flex-direction: column;
`

const InfoContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  ${'' /* margin: 3px; */}
  margin-top: 10px;
  padding: 10px 15px;
  margin-bottom: auto;
`
const HeaderContainer = styled.div`
  // background: rgba(0,0,0,0.1);
  margin: 10px 0;
`
const FormStyled = styled(Form)`
  display: flex;
`
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  // height: 160px;
`
const Header = styled.div`
  // background: rgba(0,0,0,0.1);
  font-size: 20px;
  font-weight: 600;
`
const OptionSelect = styled.div`
  direction: rtl;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const UploadButtonContainer = styled.div`
  
`
const VideoSelectStyled = styled(VideoSelect)`
  direction: ltr;
  display: flex;
  width: 100%;
`

const StatusButtonStyled = styled(StatusButton)`
  margin: 10px 0 0 auto;
`

class MyForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      isSubmitting: false,
      videoUploadProgress: 0,
    }
  }

  componentWillReceiveProps(newProps) {
    if(newProps.exerciseFormState.isSubmitting && !this.state.submitted) {
      this.props.submitForm();
      this.setState({ submitted: true });
    }
    if(!newProps.exerciseFormState.isSubmitting && this.state.submitted) {
      this.setState({ submitted: false });
    }
  }

  componentDidUpdate(prevProps) {
    const { exerciseVideos: prevExerciseVideos } = prevProps.uploadQueueState;
    const { uploadQueueState: { exerciseVideos }, values } = this.props;

    if (prevExerciseVideos && exerciseVideos &&
        prevExerciseVideos[values.id] && exerciseVideos[values.id] &&
        prevExerciseVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
        exerciseVideos[values.id].streaming_status === STREAMING_STATUS.COMPLETE) {

      // ...values.video,
      this.changeTracker([{
        id: exerciseVideos[values.id].videoId,
        thumbnail: exerciseVideos[values.id].thumbnail,
        streaming_status: exerciseVideos[values.id].streaming_status,
        video: exerciseVideos[values.id].streaming_video,
        video_orientation: exerciseVideos[values.id].video_orientation,
      }], 'video');
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  removeVideo = (video) => {
    const { values } = this.props;

    const mockVideos = values.video.filter(item => {
      if (item.id === video.id) {
        return false;
      }
      return true;
    })

    this.changeTracker(mockVideos, 'video')
  }

  videoUploadFinished = ({ awsUrl }) => {
    const { startPolling, values } = this.props;

    apiServices.addExerciseVideo({
      exercise: values.id,
      streaming_status: STREAMING_STATUS.PROCESSING,
      subtitle: '',
      video: awsUrl,
      video_orientation: DEFAULT_EXERCISE_VIDEO_ORIENTATION,
    }).then(data => {
      this.setState({ videoUploadProgress: 0 });
      startPolling({
        id: values.id,
        videoId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'exerciseVideos'
      });
    });
  }
  updateVideoUploadProgress = (videoUploadProgress) => {
    this.setState({ videoUploadProgress });
  }

  render () {
    const {
      authState: { userData },
      values,
      handleBlur,
      options,
      uploadQueueState: { exerciseVideos },
    } = this.props

    const {
      videoUploadProgress,
    } = this.state;

    values.checkValidity();

    const videoPlaceholderText = 'No Video';

    return (
      <FormStyled>
        <Container>
          <Wrapper>
            <StatusButtonStyled value={values} header="Complete Exercise" subheader="Exercise is complete when the tasks below are complete." />
            <StretchContainer>
              <Aside>
                <VideoContainer>
                  <UploadButtonContainer>
                    <FileUploader
                      accept={ACCEPTED_VIDEO_FORMATS}
                      buttonText="Upload Video"
                      fileType="exerciseVideo"
                      fullWidth
                      metadata={{ trainer_id: userData.user_id.toString() }}
                      onFinish={this.videoUploadFinished}
                      onProgress={this.updateVideoUploadProgress}
                      variant='contained'
                    />
                  </UploadButtonContainer>
                  <OptionWrapper>
                    <OptionSelect>
                      {
                        (values.video && values.video.length > 0) ? (
                          <VideoSelectStyled
                            onDelete={() => AlertModal('Delete Video','Are you sure you want to delete this video?', () => this.removeVideo(values.video[values.video.length - 1]))}
                            processing={(exerciseVideos[values.id] && exerciseVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING)}
                            thumbnail={values.video[values.video.length - 1].thumbnail}
                            video={values.video[values.video.length - 1].video}
                          />
                        ) : (
                          <ImageWrapper style={{opacity: 0.3}}>
                            <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                            {videoPlaceholderText}
                            {
                              exerciseVideos[values.id] && exerciseVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
                                <CircularProgress />
                            }
                          </ImageWrapper>
                        )
                      }
                    </OptionSelect>
                  </OptionWrapper>
                  { videoUploadProgress > 0 && (
                    <UploadProgressContainer>
                      <LinearProgress variant="determinate" value={videoUploadProgress} />
                    </UploadProgressContainer>
                  )}
                </VideoContainer>
              </Aside>
              <InfoContainer>
                <HeaderContainer>
                  <Header>Exercise Title</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  onChange={(e) => this.changeTracker(e.target.value,'name')}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <MoreDetails options={options} changeTracker={this.changeTracker} {...this.props} />
                {/* {errors.last && touched.last && <ErrorTextBox text={errors.last}/>} */}
              </InfoContainer>
            </StretchContainer>
          </Wrapper>
        </Container>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    exerciseFormState: state.exerciseFormState,
    uploadQueueState: state.uploadQueueState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
    startPolling: startPolling,
  }, dispatch)
}

export default compose(connect(mapStateToProps,mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
    last: yup.string(),
  }),

  validate: (values, props) => {
    if(props.updateForm) {
      props.updateForm(values);
    }
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'BasicForm',
}))(MyForm);
